import axios, { AxiosResponse } from 'axios';
import getApiBaseUrl from '../GetServer';

export interface Cliente {
  id: number;
  nombre: string;
  correo: string;
  telefono: string;
  status: number;
}

export interface Agente{
  id: number;
  nombre: string;
}

export interface ClientesResponse {
  status: number;
  message: string;
  data: Cliente[];
}

export interface AgentesResponse {
  statusCode: number;
  message: string;
  data: Agente[];
}

export const GetClientes = async (): Promise<Cliente[]> => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/get-cliente`;

    // Asumimos que tu token está en localStorage.getItem('token')
    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('Token de autorización no disponible');
    }

    const response: AxiosResponse<ClientesResponse> = await axios.post(
      endpoint,
      {},
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (response.data.status !== 200) {
      throw new Error(response.data.message);
    }

    console.log(response.data.data, "Clientes obtenidos");
    return response.data.data;

  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {

      throw new Error(error.response.data.message);
    }
    console.error('Error al obtener clientes:', error);
    throw error;
  }
};

export const GetAgentes = async (): Promise<Agente[]> => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/agentes`;

    // Asumimos que tu token está en localStorage.getItem('token')
    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('Token de autorización no disponible');
    }

    const response: AxiosResponse<AgentesResponse> = await axios.get(
      endpoint,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message);
    }

    console.log(response.data.data, "Agentes obtenidos");
    return response.data.data;

  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {

      throw new Error(error.response.data.message);
    }
    console.error('Error al obtener agentes:', error);
    throw error;
  }
};